import api from "../lib/api";
import PathsPage from "../components/Paths/PathsPage";

export default function Index({ centers, figures, stops }) {
  figures = figures.map((figure, index) => {
    figure.index = index;
    figure.selected = false;
    figure.stopsCoords = stops[index].map((stop) => {
      if (stop.location) {
        return [stop.location.latitude || "0", stop.location.longitude || "0"];
      } else {
        return ["0", "0"];
      }
    });
    return figure;
  });

  return <PathsPage centers={centers} figures={figures} />;
}

export async function getStaticProps({ locale }) {
  const figures = await api.getContent("/api/collections/map-persons/entries", {
    fields: ["images", "color"],
    sort: "title",
  });

  const stops = [];

  for (let index = 0; index < figures.length; index++) {
    const figure = figures[index];
    const figureStops = await api.getStops(figure.slug, "de");
    stops.push(figureStops);
  }

  const centers = await api.getCenters(locale);

  return api.injectDefaultData(
    {
      props: {
        centers,
        figures,
        stops,
      },
      revalidate: 3,
    },
    locale,
  );
}
